/* src/app/builder-screen-beta/template-detail/template-detail.component.scss */
.template-detail-container {
  width: 100%;
  min-height: 120px;
}
.template-detail-canvas {
  width: 100%;
}
/*# sourceMappingURL=template-detail.component.css.map */
